import { BUSCAR_MAPA_VEICULO_AGENDAMENTO_VIAGEM, SELECIONAR_MAPA_VEICULO_AGENDAMENTO_VIAGEM, LIMPAR_SELECAO_MAPA_VEICULO_AGENDAMENTO_VIAGEM } from '../../actions/types'

const initialState = undefined

export default function reducerMapaVeiculoAgendamentoViagem(state = [], action = initialState) {
  switch (action.type) {
    case BUSCAR_MAPA_VEICULO_AGENDAMENTO_VIAGEM: {
      return  action.payload.data;
    }

    case SELECIONAR_MAPA_VEICULO_AGENDAMENTO_VIAGEM: {
      const { assento, fileira } = action.payload;
      const andar = assento.poltrona.andar;

      let fileirasAndar;
      if (andar == 1) {
        fileirasAndar = state.fileirasPrimeiroAndar;
      } else {
        fileirasAndar = state.fileirasSegundoAndar;
      }

      const indiceFileira = fileirasAndar.indexOf(fileirasAndar.filter(f => f.id === fileira.id)[0]);
      const novo = [...fileirasAndar];

      const novaFileira = Object.assign({}, fileira);
      const novosAssentos = [...novaFileira.assentos]
      const indiceAssento = novaFileira.assentos.indexOf(assento);
      const novoAssento = Object.assign({}, assento, { selecionado: !assento.selecionado });

      novosAssentos[indiceAssento] = novoAssento;
      novaFileira.assentos = novosAssentos;
      novo[indiceFileira] = novaFileira;

      return {
        ...state,
        fileirasPrimeiroAndar: andar == 1 ? novo : state.fileirasPrimeiroAndar,
        fileirasSegundoAndar: andar == 2 ? novo : state.fileirasSegundoAndar
      }

    }

    case LIMPAR_SELECAO_MAPA_VEICULO_AGENDAMENTO_VIAGEM: {
      const { andarSelecionado } = action.payload;
      const fileirasPrimeiroAndar = state.fileirasPrimeiroAndar;
      const fileirasSegundoAndar = state.fileirasSegundoAndar;
      const novo = [...fileirasPrimeiroAndar];
      const novo2 = [...fileirasSegundoAndar];

      if (andarSelecionado == 1) {
        fileirasPrimeiroAndar.forEach((fileira, indice) => {
          const novaFileira = Object.assign({}, fileira);        
          const novosAssentos = [...novaFileira.assentos];
          const todosAssentos = novosAssentos.map(assento => Object.assign({}, assento, { selecionado: false }));
          novaFileira.assentos = todosAssentos;
          novo[indice] = novaFileira;
        });
      }

      if (andarSelecionado == 2) {
        fileirasSegundoAndar.forEach((fileira, indice) => {
          const novaFileira = Object.assign({}, fileira);        
          const novosAssentos = [...novaFileira.assentos];
          const todosAssentos = novosAssentos.map(assento => Object.assign({}, assento, { selecionado: false }));
          novaFileira.assentos = todosAssentos;
          novo2[indice] = novaFileira;
        });
      }

      return {
        ...state,
        fileirasPrimeiroAndar: andarSelecionado == 1 ? novo : state.fileirasPrimeiroAndar,
        fileirasSegundoAndar: andarSelecionado == 2 ? novo2 : state.fileirasSegundoAndar
      }

    }

    default: {
      return state
    }
  }
}
